import { render, staticRenderFns } from "./AuthorManage.vue?vue&type=template&id=8069d7f2&scoped=true"
import script from "./AuthorManage.vue?vue&type=script&lang=js"
export * from "./AuthorManage.vue?vue&type=script&lang=js"
import style0 from "./AuthorManage.vue?vue&type=style&index=0&id=8069d7f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8069d7f2",
  null
  
)

export default component.exports